module.exports = __webpack_public_path__ + "static/media/icon_comment-group-color.383bac73.svg";